/**
 * User: n.gorte
 * Date: 28.03.2019
 * Time: 11:28
 */
'use strict';
import React from 'external/react';
import ReactQuill from 'external/react-quill';
import 'external/react-quill-css';
import PropTypes from 'external/prop-types';
import '../css/_wysiwyg.scss';

const DEFAULT_MODULES = {
    toolbar: [
        [{ 'header': [4, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['link']
    ]
};

const DEFAULT_FORMATS = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link'
];

export const WYSIWYGEditor = ({ 
    placeholder, 
    style, 
    value,
    onChange,
    formats = DEFAULT_FORMATS, 
    modules = DEFAULT_MODULES
}) => {

    const onEditorChange = (value, delta, source, editor) => {
        //Every change of value seems to trigger a direct onChange.
        //If to or more changes a queued in the async dispatcher this may cause a loop where every change causes a new change.
        //Because of this we filter out all api changes. This should work as long as no external changes are made over the api.
        if (source === 'api') {
            console.log('onEditorChange api', value, source);
        } else {
            onChange(value);
        }
    };

    return (
        <ReactQuill
            className="fliwas-wysiwyg-editor"
            style={style}
            placeholder={placeholder}
            value={value}
            onChange={onEditorChange}
            modules={modules}
            formats={formats}
        />
    );
};

WYSIWYGEditor.propTypes = {
    placeholder: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    formats: PropTypes.arrayOf(PropTypes.string),
    modules: PropTypes.object
};



// WEBPACK FOOTER //
// ./js/components/WYSIWYGEditor.jsx